import { render, staticRenderFns } from "./OsTranslationFileUploader.vue?vue&type=template&id=bb63131a&scoped=true"
import script from "./OsTranslationFileUploader.vue?vue&type=script&lang=ts"
export * from "./OsTranslationFileUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb63131a",
  null
  
)

export default component.exports